import { FieldRenderFilters } from '.';

const KEYS = {
  createdBy: '@combined_created',
  title: 'b392',
  description: '0391',
  issueType: 'c9f6',
  priority: '9688',
  linkedTasks: 'ccc1',
  project: '@project',
  status: '@status',
  mediaPhotos: '7a79',
  location: '@location',
  resolutionSection: '4f50',
  resolutionDescription: 'a8f1',
  resolutionPhotos: '49bc',
  titleSection: '76tr',
  mediaSection: '8i3k',
};

const basicIssue = [
  {
    key: KEYS.status,
    changes: [
      {
        attributeName: 'required',
        value: false,
      },
      {
        attributeName: 'hidden',
        value: false,
      },
    ],
  },
  {
    key: KEYS.titleSection,
    changes: [
      { attributeName: 'label', value: 'Details' },
      { attributeName: 'data_name', value: 'details' },
      { attributeName: 'display', value: 'tab' },
    ],
    children: [
      {
        key: KEYS.createdBy,
        changes: [
          {
            attributeName: 'shouldRender',
            value: ({ record }: FieldRenderFilters) => (record.created_by && record.created_at),
          },
        ],
      },
      {
        key: KEYS.title,
      },
      {
        key: KEYS.description,
        changes: [
          {
            attributeName: 'description',
            value: '',
          },
        ],
      },
      {
        key: KEYS.issueType,
      },
      {
        key: KEYS.priority,
      },
      {
        key: KEYS.project,
      },
      {
        key: KEYS.mediaSection,
        changes: [
          {
            attributeName: 'display',
            value: 'drilldown',
          },
        ],
        children: [
          {
            key: KEYS.mediaPhotos,
          },
        ],
      },
      {
        key: KEYS.location,
      },
      {
        key: KEYS.linkedTasks,
      },
    ],
  },
  {
    key: KEYS.resolutionSection,
    changes: [
      {
        attributeName: 'display', value: 'tab',
      },
    ],
    children: [
      {
        key: KEYS.resolutionDescription,
        changes: [
          {
            attributeName: 'label', value: 'Description',
          },
        ],
      },
      {
        key: KEYS.mediaSection,
        children: [
          {
            key: KEYS.resolutionPhotos,
          },
        ],
      },
    ],
  },
];

export default basicIssue;
